import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgTicket extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 210 210" height={size}>
                <g id="layer1" transform="translate(0,-87)">
                    <g
                        data-name="Page tickets en attente"
                        id="Page_tickets_en_attente"
                        transform="matrix(0.84604901,0,0,0.84604901,34.104416,92.006563)"
                    >
                        <path
                            id="path3786"
                            fill={color}
                            transform="translate(-41.47,-31.65)"
                            d="M 178,83.2 H 71.71 a 7.5,7.5 0 0 1 0,-15 H 178 a 7.5,7.5 0 0 1 0,15 z"
                        />
                        <path
                            id="path3788"
                            fill={color}
                            transform="translate(-41.47,-31.65)"
                            d="M 178,129.78 H 71.71 a 7.5,7.5 0 1 1 0,-15 H 178 a 7.5,7.5 0 0 1 0,15 z"
                        />
                        <path
                            id="path3790"
                            fill={color}
                            d="M 178,176.36 H 71.71 a 7.5,7.5 0 0 1 0,-15 H 178 a 7.5,7.5 0 0 1 0,15 z"
                            transform="translate(-41.47,-31.65)"
                        />
                        <path
                            id="path3792"
                            fill={color}
                            transform="translate(-41.47,-31.65)"
                            d="m 202.92,259.36903 c 3.20368,-0.076 5.7609,-4.16013 5.76,-7.36471 V 37.54 c 0,-3.25848 -2.64152,-5.9 -5.9,-5.9 H 47.37 c -3.25848,0 -5.9,2.64152 -5.9,5.9 v 224.92 c 0,3.25848 2.64152,5.9 5.9,5.9 h 155.42 c 3.25848,0 5.9,-2.64152 5.9,-5.9 v -17.31 c 0.13804,-3.35092 -2.54125,-6.14284 -5.895,-6.14284 -3.35375,0 -6.03304,2.79192 -5.895,6.14284 v 11.41 H 53.26 V 43.44 h 143.63 v 205.6449 c 0.005,3.30601 2.72479,10.35698 6.03,10.28413 z"
                        />
                        <path
                            id="path3790-7"
                            fill={color}
                            d="M 136.12743,190.85665 H 29.837431 a 7.5000001,7.5000001 0 0 1 0,-15 H 136.12743 a 7.5000001,7.5000001 0 0 1 0,15 z"
                        />
                    </g>
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgTicket);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgTicket.js